/**
 * Created by r4zi4l on 09.11.2021
 */

const ExpeditionPassWindow = CleverappsWindow.extend({
    ctor: function (mission, ...args) {
        this.mission = mission;

        this._super.call(this, mission, ...args);
    },

    onWindowLoaded: function (mission) {
        const options = {
            name: "ExpeditionPassWindow",
            title: Messages.get("ExpeditionPassWindow.title"),
            content: new PassWindowContent({
                components: [{
                    name: "progress",
                    class: PassProgress
                }, {
                    name: "tickets",
                    class: PassTickets,
                    params: { close: this.close.bind(this) }
                },
                {
                    name: "header",
                    class: ExpeditionPassHeader,
                    params: {
                        pack_json: bundles[`expeditionpass_${cleverapps.skins.getSlot("skinName")}`].jsons.pack_json,
                        close: this.close.bind(this)
                    }
                }],
                width: cleverapps.styles.ExpeditionPassWindow.width,
                styles: cleverapps.styles.ExpeditionPassWindow,
                passLogic: mission.logic
            }),
            foreground: bundles.passforeground.frames.pass_window_foreground_png,
            closeButton: true,
            noPadding: true,
            styles: cleverapps.styles.ExpeditionPassWindow.window
        };

        if (mission.guideWindow) {
            options.help = function () {
                let options = mission.guideWindow;
                const multipassName = `${cleverapps.skins.getSlot("skinName")}_multipass_guidewindow`;
                if (bundles[multipassName] && ["undersea2", "dragonia2"].indexOf(cleverapps.meta.selectedLocationId()) === -1) {
                    options = {
                        name: multipassName,
                        bundle: bundles[multipassName]
                    };
                }

                cleverapps.focusManager.display({
                    focus: "ExpeditionPassGuideWindow",
                    stack: true,
                    action: (f) => {
                        new GuideWindow(options);
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            };
        }

        this._super(options);
    },

    onShow: function () {
        this._super();
        this.mission.logic.handleShowWindow();
    },

    onClose: function () {
        cleverapps.focusManager.hideControlsWhileFocused(["MenuBarGoldItem", "MenuBarLivesItem"]);
    },

    listBundles: function () {
        return [`expeditionpass_${cleverapps.skins.getSlot("skinName")}`];
    }

});
 
cleverapps.styles.ExpeditionPassWindow = {
    width: 1712,
    height: 844,

    window: {
        Foreground: {
            contentPadding: {
                top: 300
            }
        }
    },

    progress: {
        x: { align: "right", dx: 0 },
        y: { align: "bottom", dy: -37 }
    },

    header: {
        x: { align: "center" },
        y: { align: "top", dy: 24 }
    },

    tickets: {
        x: { align: "left", dx: 0 },
        y: { align: "center", dy: -106 }
    }
};
